import { useState, useMemo, createContext, useContext } from "react";

const FiltersContext = createContext();

export function useFilters() {
  return useContext(FiltersContext);
}

export function FiltersProvider({ props, children }) {
  const [projectKey, setProjectKey] = useState([]);
  const [fixVersion, setFixVersion] = useState([]);
  const [issueStatus, setIssueStatus] = useState([]);

  const value = useMemo(
    () => ({
      projectKey,
      setProjectKey,
      fixVersion,
      setFixVersion,
      issueStatus,
      setIssueStatus,
    }),
    [projectKey, fixVersion, issueStatus]
  );

  return (
    <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
  );
};
